import { styled, css } from 'styled-components';

import { Media } from '../../../../../theme/Media.tsx';
import { StyledLabel } from '../../../../Form/Label/index.tsx';
import { ALIGN_TO_FLEX, CELL_PADDING_COMPACT, CELL_PADDING_DEFAULT, MOBILE_PADDING, SPECIAL_CONTENT_TYPES } from '../../constants.ts';
import { actionCellStyles, checkboxCellStyles, dndCellStyles, specialCellCenter } from '../../mixins.ts';
import { TableCellContentType } from '../../types.ts';

interface HeadWrapperProps {
  $align: 'center' | 'left' | 'right' | undefined;
  $contentType: TableCellContentType | undefined;
  $order: 'ASC' | 'DESC' | undefined;
  $sortable: boolean | undefined;
  $compact: boolean | undefined;
}

export const HeadWrapper = styled.div<HeadWrapperProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  ${({ $align }) =>
    $align &&
    css`
      justify-content: ${ALIGN_TO_FLEX[$align]};
    `}
  min-height: 20px;
  padding: ${({ $contentType, $compact }) => {
    if ($contentType && SPECIAL_CONTENT_TYPES.has($contentType)) return '0';
    return $compact ? CELL_PADDING_COMPACT : CELL_PADDING_DEFAULT;
  }};
  ${({ theme }) => theme.typography.textSmall};
  color: ${({ theme, $order }) => ($order ? theme.colors.black_1 : theme.colors.grey100_1)};
  cursor: ${({ $sortable }) => ($sortable ? 'pointer' : 'default')};
  white-space: nowrap;

  @media ${Media.smMin} {
    ${({ $contentType }) => $contentType && SPECIAL_CONTENT_TYPES.has($contentType) && specialCellCenter}

    ${({ $contentType, $compact }) => $contentType === TableCellContentType.DND && dndCellStyles($compact)}
    ${({ $contentType, $compact }) => $contentType === TableCellContentType.CHECKBOX && checkboxCellStyles($compact)}
    ${({ $contentType, $compact }) => $contentType === TableCellContentType.ACTION && actionCellStyles($compact)}

    ${({ theme, $sortable }) =>
      $sortable &&
      css`
        &:hover {
          background: ${theme.colors.grey05_1};
        }
      `}

    ${StyledLabel} {
      display: none;
    }
  }

  @media ${Media.xsMax} {
    ${({ $contentType }) =>
      $contentType === TableCellContentType.CHECKBOX
        ? css`
            display: flex;
            padding: ${MOBILE_PADDING};

            & > label {
              width: 100%;
            }
          `
        : css`
            display: none;
          `}
  }
`;
